module.exports = __webpack_public_path__ + "static/hero-career-pathing-c9096fbf8801bb318597bbc387e1281a.svg";